import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const TabStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      fontSize: "15px",
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      marginBottom: "0.5em",
      [theme.breakpoints.down("xs")]: {
        fontSize: "10px",
        fontWeight: 800,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        marginBottom: "1em",
      },
    },
  })
);
